import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Search, Trash2 } from "lucide-react";
import { supabase } from "../../../lib/supabase";
import { deleteFromFtp } from "../../../lib/deleteFromFtp";

interface VideoItem {
  id: string;
  title: string;
  description: string;
  url: string;
}

const VideoList: React.FC = () => {
  const [videos, setVideos] = useState<VideoItem[]>([]);
  const [filteredVideos, setFilteredVideos] = useState<VideoItem[]>([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
        const { data, error } = await supabase.from('videos').select('*');
        if (error) {
            console.error(error);
        } else {
            setVideos(data as VideoItem[]);
            setFilteredVideos(data as VideoItem[]);
        }
        setLoading(false);
    };
    fetchVideos();
  }, []);

  const handleDelete = async (id: string) => {
      if(!window.confirm("Bu videoyu silmek istediğinize emin misiniz?")) return;
      
      const itemToDelete = videos.find(v => v.id === id);

      try {
          const { error } = await supabase.from('videos').delete().eq('id', id);
          if (!error) {
              if (itemToDelete?.url) deleteFromFtp(itemToDelete.url);
              const fetchVideos = async () => {
                  const { data, error } = await supabase.from('videos').select('*');
                  if (!error) {
                      setVideos(data as VideoItem[]);
                      setFilteredVideos(data as VideoItem[]);
                  }
              };
              fetchVideos();
          } else {
              console.error(error);
          }
      } catch (error) {
          console.error(error);
      }
  }

  useEffect(() => {
    const results = videos.filter((item) =>
      item.title.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredVideos(results);
  }, [search, videos]);

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Video Yönetimi</h1>
          <p className="text-gray-500">Tüm videoları görüntüleyin ve düzenleyin</p>
        </div>
        <Link
          to="/panel/videos/add"
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg flex items-center shadow-sm transition-all"
        >
          <Plus className="w-5 h-5 mr-2" />
          Yeni Video Ekle
        </Link>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="p-4 border-b border-gray-100">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Video ara..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {loading ? (
          <div className="p-8 text-center text-gray-500">Yükleniyor...</div>
        ) : filteredVideos.length === 0 ? (
          <div className="p-8 text-center text-gray-500">Video bulunamadı.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead className="bg-gray-50 text-gray-600 font-medium text-sm">
                <tr>
                  <th className="p-4">Video</th>
                  <th className="p-4">Başlık</th>
                  <th className="p-4">Açıklama</th>
                  <th className="p-4">İşlem</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredVideos.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                    <td className="p-4">
                      <div className="w-24 h-16 rounded bg-black overflow-hidden relative">
                         <video
                           src={item.url}
                           className="w-full h-full object-cover"
                         />
                      </div>
                    </td>
                    <td className="p-4 font-medium text-gray-800">{item.title}</td>
                    <td className="p-4 text-gray-500 line-clamp-2">{item.description}</td>
                    <td className="p-4">
                        <button onClick={() => handleDelete(item.id)} className="text-red-500 hover:text-red-700">
                            <Trash2 size={20} />
                        </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoList;
